export default "__VITE_ASSET__53a1c204__"